import { useEffect, useState } from "react";
import { TOKEN } from "@/lib/site";

// Shared live-price fetcher (DexScreener public API). Polls every 30s.
export const usePrice = () => {
  const [data, setData] = useState(null);
  const [state, setState] = useState("loading"); // loading | ok | empty | error

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await fetch(
          `https://api.dexscreener.com/latest/dex/tokens/${TOKEN.contract}`
        );
        const json = await res.json();
        const pair = json?.pairs?.[0];
        if (!alive) return;
        if (pair) {
          setData(pair);
          setState("ok");
        } else {
          setState("empty");
        }
      } catch (e) {
        if (alive) setState("error");
      }
    };
    load();
    const id = setInterval(load, 30000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  const change = data ? Number(data.priceChange?.h24 ?? 0) : 0;
  return { data, state, change, up: change >= 0 };
};

export const fmtPrice = (p) => {
  const n = Number(p);
  if (!n || Number.isNaN(n)) return "--";
  if (n >= 1) return `$${n.toLocaleString(undefined, { maximumFractionDigits: 4 })}`;
  return `$${n.toPrecision(4)}`;
};

export const fmtCompact = (v) => {
  const n = Number(v);
  if (!n || Number.isNaN(n)) return "--";
  return `$${Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 2 }).format(n)}`;
};
